export const PENDING = 'pending';
export const CURRENT = 'current';
